<template>
    <div class="custom-checkbox">
        <the-btn
            text="Zaznacz wszystkie"
            class="btn-outline-custom d-none d-sm-inline-flex"
            :class="{ 'd-inline-flex': !value }"
            icon="CheckCorrect"
            @click="$emit('select', true)"
        />
        <the-btn
            text="Odznacz wszystkie"
            class="btn-danger ml-sm-2 d-none d-sm-inline-flex"
            :class="{ 'd-inline-flex': value }"
            icon="CheckIncorrect"
            @click="$emit('select', false)"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true
        }
    }
}
</script>
